import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';

export function configureStore(initialState = {}, reducers = {}) {
  const middlewares = [thunkMiddleware];

  if (__DEV__ && __REDUX_LOGGER__) {
    const { createLogger } = require('redux-logger');
    middlewares.push(createLogger());
  }

  const composeEnhancers =
    __DEV__ === true && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          trace: true,
        })
      : compose;

  // We'll create a Store that has our Reducers and an initial state,
  // with added Thunk middleware to make async actions possible.
  const store = createStore(
    combineReducers(reducers),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  store.asyncReducers = {};

  // https://redux.js.org/recipes/code-splitting/#defining-an-injectreducer-function
  store.injectReducer = (key, asyncReducer) => {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(createReducer(store.asyncReducers));
  };

  function createReducer(asyncReducers) {
    return combineReducers({
      ...reducers,
      ...asyncReducers,
    });
  }

  return store;
}
